var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"fas fa-arrow-circle-left"})])
}
var staticRenderFns = []

export { render, staticRenderFns }